import { ADMIN_USER_API_PATH } from 'constants/api';
import { roleService } from 'permission/role/service/roleService';
import { RolePermissionType } from 'permission/role/type/roleType';
import { ApiService } from 'service/api/apiService';
import { companyApiService } from 'service/api/companyApiService';
import { accountStore } from 'store/accountStore';
import { TableDataInterface } from 'type/tableType';
import { UserServiceType, UserSettingDataInterface } from '../types/userServiceType';
import { UserDetailType, UserInterface } from '../types/userType';

export class UserService implements UserServiceType {
  constructor(private readonly apiService: ApiService<UserInterface>) {}

  public async fetchUserWithRole(id: number): Promise<UserDetailType> {
    const user = await this.apiService.fetchById(id);
    const roles = await this.apiService.fetchChildItemsByParentId<{ role: RolePermissionType }[]>(
      id,
      '/roles/'
    );
    const userRoles = roles.map(role => role.role);
    return { ...user, roles: userRoles };
  }

  public async fetchUserListWithRole(
    queryParams: URLSearchParams
  ): Promise<TableDataInterface<UserDetailType>> {
    const userList = await this.apiService.fetch(queryParams);
    const userListWithRole = await Promise.all(
      userList.results.map(async user => {
        const roles = await this.apiService.fetchChildItemsByParentId<
          { role: RolePermissionType }[]
        >(user.id, '/roles/');
        const userRoles = roles.map(role => role.role);
        return { ...user, roles: userRoles };
      })
    );
    return { data: userListWithRole, count: userList.count };
  }

  public async fetchUserSettingData(): Promise<UserSettingDataInterface> {
    const profile = accountStore.getAccount();
    const companyList = await companyApiService.fetchAllSortedCompanyList();
    const roleList = await roleService.fetch();
    return { companyList, roleList: roleList.results, platform: profile?.platform };
  }

  public async creatUserWithRole(user: UserInterface, roleIds: number[]): Promise<UserInterface> {
    const createdUser = await this.apiService.create(user);
    await this.apiService.createItemsForParent(createdUser.id, '/roles/', {
      role_ids: roleIds,
    });
    return createdUser;
  }

  public async updateUserWithRole(
    id: number,
    user: UserInterface,
    roleIds: number[]
  ): Promise<void> {
    await this.apiService.update(id, user);
    await this.apiService.updateItemsForParent(id, '/roles/', {
      role_ids: roleIds,
    });
  }
}

export const userService = new UserService(new ApiService(ADMIN_USER_API_PATH));
